var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", { value: raw });
    }
    else {
        cooked.raw = raw;
    }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef, useCallback, useEffect } from 'react';
import Modal from 'react-modal';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import styled from 'styled-components';
import { getCroppedImg } from './CropImage';
var customModalStyles = {
    content: {
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        background: '#fff',
        borderRadius: '10px',
        padding: '16px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
        zIndex: 1000,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '700px',
        height: '700px',
        maxWidth: '90vw',
        maxHeight: '90vh',
    },
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 999,
    },
};
var CropModal = function (_a) {
    var isOpen = _a.isOpen, image = _a.image, onClose = _a.onClose, onCropComplete = _a.onCropComplete;
    var _b = useState({
        unit: 'px',
        width: 0,
        height: 0,
        x: 0,
        y: 0,
    }), crop = _b[0], setCrop = _b[1];
    var _c = useState(null), completedCrop = _c[0], setCompletedCrop = _c[1];
    var _d = useState(false), isTall = _d[0], setIsTall = _d[1];
    var imgRef = useRef(null);
    var onCropChange = function (newCrop) {
        setCrop(newCrop);
    };
    var onCropCompleteInternal = function (croppedArea) {
        setCompletedCrop(croppedArea);
    };
    var onImageLoad = useCallback(function (e) {
        var img = e.currentTarget;
        if (imgRef.current) {
            imgRef.current = img;
        }
        var aspect = 1; // Квадратное соотношение сторон
        var isImageTall = img.height > img.width;
        console.log(img.height, img.width);
        setIsTall(isImageTall);
        var width, height, x, y;
        if (isImageTall) {
            console.log(isImageTall, 'taaaaall');
            height = 100; // Фиксированная высота
            width = 100;
            x = 0;
            y = 0;
        }
        else {
            height = img.height * 0.8; // 80% высоты
            width = height * aspect;
            x = (img.width - width) / 2;
            y = (img.height - height) / 2;
        }
        setCrop({
            unit: 'px',
            width: width,
            height: height,
            x: x,
            y: y,
        });
        setCompletedCrop({
            unit: 'px',
            width: width,
            height: height,
            x: x,
            y: y,
        });
    }, []);
    useEffect(function () {
        if (isOpen && image) {
            var img = imgRef.current;
            if (img) {
                var aspect = 1; // Квадратное соотношение сторон
                var isImageTall = img.height > img.width;
                console.log(img.height, img.width);
                setIsTall(isImageTall);
                var width = void 0, height = void 0, x = void 0, y = void 0;
                if (isImageTall) {
                    console.log(isImageTall, 'taaaaall');
                    height = 100; // Фиксированная высота
                    width = 100;
                    x = 0;
                    y = 0;
                }
                else {
                    height = img.height * 0.8; // 80% высоты
                    width = height * aspect;
                    x = (img.width - width) / 2;
                    y = (img.height - height) / 2;
                }
                setCrop({
                    unit: 'px',
                    width: width,
                    height: height,
                    x: x,
                    y: y,
                });
                setCompletedCrop({
                    unit: 'px',
                    width: width,
                    height: height,
                    x: x,
                    y: y,
                });
            }
        }
        else {
            setCrop({
                unit: 'px',
                width: 0,
                height: 0,
                x: 0,
                y: 0,
            });
            setCompletedCrop(null);
            setIsTall(false);
        }
    }, [isOpen, image]);
    var handleCrop = function () {
        return __awaiter(void 0, void 0, void 0, function () {
            var croppedImage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(completedCrop && image && imgRef.current))
                            return [3 /*break*/, 2];
                        return [4 /*yield*/, getCroppedImg(imgRef.current, completedCrop)];
                    case 1:
                        croppedImage = _a.sent();
                        onCropComplete(croppedImage);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    return (_jsxs(Modal, __assign({ isOpen: isOpen, onRequestClose: onClose, style: customModalStyles, contentLabel: "Crop Image" }, { children: [_jsx(HeaderText, { children: "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0444\u043E\u0442\u043E" }), _jsx(ContentContainer, { children: _jsx(ReactCrop, __assign({ crop: crop, onChange: onCropChange, onComplete: onCropCompleteInternal, aspect: 1, keepSelection: true }, { children: _jsx(StyledImage, { ref: imgRef, src: image, alt: "Crop me", onLoad: onImageLoad, isTall: isTall }) })) }), _jsxs(ButtonContainer, { children: [_jsx(Button, __assign({ onClick: handleCrop }, { children: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C" })), _jsx(Button, __assign({ onClick: onClose }, { children: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C" }))] })] })));
};
var StyledImage = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  min-height: ", ";\n  max-width: ", ";\n  object-fit: contain;\n"], ["\n  width: ", ";\n  height: ", ";\n  min-height: ", ";\n  max-width: ", ";\n  object-fit: contain;\n"])), function (_a) {
    var isTall = _a.isTall;
    return (isTall ? 'auto' : '100%');
}, function (_a) {
    var isTall = _a.isTall;
    return (isTall ? '550px' : '100%');
}, function (_a) {
    var isTall = _a.isTall;
    return (isTall ? '550px' : 'auto');
}, function (_a) {
    var isTall = _a.isTall;
    return (isTall ? '100%' : 'auto');
});
var ContentContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  background: #f0f0f0; // \u0414\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u043E \u0434\u043B\u044F \u043B\u0443\u0447\u0448\u0435\u0433\u043E \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\n"], ["\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  background: #f0f0f0; // \u0414\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u043E \u0434\u043B\u044F \u043B\u0443\u0447\u0448\u0435\u0433\u043E \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\n"])));
var ButtonContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  width: 50%;\n  align-items: flex-start;\n  margin-top: 16px;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  width: 50%;\n  align-items: flex-start;\n  margin-top: 16px;\n"])));
var Button = styled.button(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding: 15px;\n  margin: 0 8px;\n  border-radius: 30px;\n  background: #e621d3;\n  border: none;\n  cursor: pointer;\n  color: #fff;\n  font-family: 'Montserrat Regular';\n  font-weight: 500;\n  font-size: 16px;\n  flex: 1;\n  text-align: center;\n\n  &:nth-child(2) {\n    background: none;\n    color: #000000;\n  }\n"], ["\n  padding: 15px;\n  margin: 0 8px;\n  border-radius: 30px;\n  background: #e621d3;\n  border: none;\n  cursor: pointer;\n  color: #fff;\n  font-family: 'Montserrat Regular';\n  font-weight: 500;\n  font-size: 16px;\n  flex: 1;\n  text-align: center;\n\n  &:nth-child(2) {\n    background: none;\n    color: #000000;\n  }\n"])));
var HeaderText = styled.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  background: #fff;\n  width: 50%;\n  margin-bottom: 16px;\n  align-self: center;\n  justify-self: center;\n  font-family: 'Montserrat Regular';\n  font-weight: 400;\n  font-size: 16px;\n  text-align: center;\n  padding-bottom: 16px;\n"], ["\n  background: #fff;\n  width: 50%;\n  margin-bottom: 16px;\n  align-self: center;\n  justify-self: center;\n  font-family: 'Montserrat Regular';\n  font-weight: 400;\n  font-size: 16px;\n  text-align: center;\n  padding-bottom: 16px;\n"])));
export default CropModal;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
